import cx from '@utils/cx.util';
import React from 'react';

type DigitsProps = {
  value: number;
  className?: string;
  size?: string;
};

const clampTwoDigits = (n: number) => {
  if (!Number.isFinite(n)) return 0;
  if (n < 0) return 0;
  if (n > 99) return 99;
  return Math.floor(n);
};

const Digits: React.FC<DigitsProps> = ({ value, className }) => {
  const v = clampTwoDigits(value);

  return (
    <span className={cx('tw:inline-flex tw:tabular-nums', className)}>
      <span
        className='countdown-digits tw:relative tw:inline-block tw:h-[1em] tw:overflow-hidden tw:text-3xl tw:leading-[1em]'
        style={{ '--value': v } as React.CSSProperties}
      />
    </span>
  );
};

export default Digits;
